/**
 * CompatibilityBoardConnected — the interactive Y-site matrix board wired to
 * its data: the build-time matrix snapshot. ONE wiring, rendered in two homes:
 *   - full-screen in the compatibility satellite app (apps/compatibility),
 *   - inline in the main app's Home detail pane (the agent working IN the frame).
 * The bare <CompatibilityBoard> stays presentational; this owns the data so the
 * two surfaces can never drift. Keyed by session id so opening another session
 * remounts clean.
 *
 * `session` is optional — the session-less Home render and /sessions/new: the
 * matrix is a build-time snapshot, so the board (drug picker, verdict) renders
 * fully without one, and nothing on it writes to a session.
 */
import { CompatibilityBoard } from './CompatibilityBoard'
import { useCompatibilityMatrix } from '../../hooks/useCompatibilityMatrix'
import type { SessionDetail } from '@frontend/hooks/useSessions'

interface CompatibilityBoardConnectedProps {
  session?: SessionDetail
}

export function CompatibilityBoardConnected({ session }: CompatibilityBoardConnectedProps) {
  // The matrix is a build-time snapshot — a plain value, no fetch.
  const matrix = useCompatibilityMatrix()
  return <CompatibilityBoard key={session?.session.id} state={matrix} />
}
